import { useIntl } from 'react-intl'
import clsx from 'clsx'
import styled from 'styled-components'
import { rem } from 'polished'
import IconButton from 'LuxKit/Button/IconButton'
import LineArrowDownIcon from 'LuxKit/Icons/line/LineArrowDownIcon'
import noop from 'lib/function/noop'

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: ${rem(16)};
  z-index: 10;
  
  opacity: 0;
  pointer-events: none;
  
  transition: opacity 0.2s ease;
  
  &.visible {
    opacity: 1;
    pointer-events: auto;
  }
`

const StyledIconButton = styled(IconButton)`
  box-shadow: 0 ${rem(4)} ${rem(12)} rgba(15, 23, 42, 0.15), 0 ${rem(2)} ${rem(6)} rgba(15, 23, 42, 0.1);
`

interface Props {
  visible: boolean
  onClick?: () => void
}

export default function ScrollToBottomButton({ visible, onClick = noop }: Props) {
  const intl = useIntl()

  const scrollToBottomAriaLabel = intl.formatMessage({
    id: 'JtEwYrQXHepi-d_CAscE',
    defaultMessage: 'Scroll to bottom',
    description: 'Accessible label for the scroll to bottom button in the chat panel',
  })

  return (
    <ButtonWrapper className={clsx({ visible })}>
      <StyledIconButton
        kind="secondary"
        variant="dark"
        shape="circle"
        size="large"
        onClick={onClick}
        aria-label={scrollToBottomAriaLabel}
        aria-hidden={!visible}
        type="button"
      >
        <LineArrowDownIcon />
      </StyledIconButton>
    </ButtonWrapper>
  )
}
